// extracted by mini-css-extract-plugin
module.exports = {"form":"MealItemForm_form__2GhM6","input":"MealItemForm_input__1vunm","input-label":"MealItemForm_input-label__3_wxy","input-input--box":"MealItemForm_input-input--box__3kxHd"};